// extracted by mini-css-extract-plugin
export var greenDivClass = "Feedback-module--greenDivClass---g9J5";
export var answerBoxClass = "Feedback-module--answerBoxClass--YA-y0";
export var answerTextClass = "Feedback-module--answerTextClass--gGfhC";
export var formClass = "Feedback-module--formClass--BvtYn";
export var inputDiv = "Feedback-module--inputDiv--qCnXj";
export var sendBtnClass = "Feedback-module--sendBtnClass--3S2i8";